<template>
<div>
  <v-dialog v-model="dialogApprover" persistent max-width="650px">
  <OverlayLoading :loading="loading" />
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">{{typeAction}}ข้อมูลพนักงาน</span>
        <!-- <UpdateTitleOrgchart titlename="เพิ่มผู้อนุมัติ" style="text-decoration: underline;" :btnDel="false" /> -->
      </v-card-title>
      <v-card-text>
        <v-row class="align-center" justify="start">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <span class="ra-head-text" style="">เลือกประเภท</span>
          </v-col>
          <div class="">
            <v-radio-group
              v-model="radios"
              row
              >
              <v-radio
                class="radio-border"
                color="#2BA197"
                label="ตนเอง"
                value="ตนเอง"
              ></v-radio>
              <v-radio
                class="radio-border"
                color="#2BA197"
                label="ค้นหาจาก Email One ID"
                value="EmailOneID"
              ></v-radio>
              <!-- <v-radio
                class="radio-border"
                label="ค้นหาจาก One ID"
                value="ค้นหาจาก One ID"
              ></v-radio> -->
            </v-radio-group>
          </div>
        </v-row>
        <v-row v-if="radios === 'EmailOneID'">
          <v-col cols="12">
            <v-autocomplete
              v-model="dataSearchEmployee"
              @change="searchEmployee(dataSearchEmployee)"
              :items="itemUser"
              item-text="dataShow"
              item-value="emailOneId"
              :search-input.sync="searchEmpoyee"
              outlined
              dense
              class="mt-2"
              placeholder="ค้นหาจากชื่อหรือ Email One ID"
              no-data-text="ไม่พบข้อมูล"
              @keyup="getUser($event.target.value)"
            >
              <template v-slot:append>
                <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchEmployee(dataSearchEmployee), page=1">
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-3 mb-2">
          <span>ผลการค้นหา</span>
        </v-row>
        <div class="pa-3" style="background-color: #F8F9FB; height: 300px;">
          <v-avatar
            v-if="searchEmpoyee !== null || employeeIdDefault !==''"
            class="mt-1 ml-2"
            size="80"
            rounded
            style="float: left;"
            >
            <v-img
              class="card-header-userimg-border"
              cover
              :lazy-src="require('@/assets/icons/no_user.png')"
              :src="failed_image ? require('@/assets/icons/no_user.png') : img"
              :alt="employeeId"
              v-on:error="onImgError()"
              aspect-ratio="1"
              height="100%"
            />
          </v-avatar>
          <v-row v-if="searchEmpoyee !== null || employeeIdDefault !==''" class="pl-2 pr-5 mb-5 align-center">
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">รหัสพนักงาน</p>
              <span class="txt-font" style="color: #333;">{{employeeId}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">ชื่อ-สกุล</p>
              <span class="txt-font" style="color: #333;">{{fNameTh}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">ตำแหน่ง</p>
              <span class="txt-font" style="color: #333;">{{position}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">อีเมล</p>
              <span class="txt-font" style="color: #333;">{{email}}</span>
            </v-col>
            <!-- <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">บริษัท</p>
              <span class="txt-font" style="color: #333;">{{companyName}}</span>
            </v-col> -->
            <!-- <v-spacer></v-spacer>
            <v-col cols="2" sm="12" md="2" lg="2" class="pa-0">
              <v-btn
                color="red" dark
                class="create-orgchart-header-cancel-btn pa-3"
                @click="clearSearchEmployee()"
                >
                  ล้างข้อมูล
                <v-icon right dark>fa-times</v-icon>
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row v-else class="pl-3" justify="center">
            <span class="ra-head-text mt-15">ไม่มีข้อมูล</span>
          </v-row>
        </div>
        <!-- <FullLoading :loading="loadingUsers"></FullLoading> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="button-color-outline" outlined @click="closeDialog">ยกเลิก</v-btn>
        <v-btn v-if="type === 'approver'" class="button-color" dark @click="confirmApprove()">เพิ่มข้อมูล</v-btn>
        <v-btn v-if="type === 'temporaryer'" class="button-color" dark @click="confirmApprove()">เพิ่มข้อมูล</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import {
  // getUserByKeyword, // เก่า
  getUserByEmployee, // ใหม่
  searchSelectEmployee,
  hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      tokenUser: this.$store.state.token,
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogApprover: false,
      failed_image: false,
      radios: null,
      employeeIdDefault: '',
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      fNameTh: '',
      lNameTh: '',
      email: '',
      approveType: 'ผู้อนุมัติ',
      companyName: '',
      companyId: '',
      img: '',
      employeeId: '',
      id: '',
      position: '',
      userImg: '',
      dataSearchEmployee: '',
      action: '',
      type: '',
      index: '',
      items: [],
      itemUser: [],
      search: null,
      select: null,
      searchEmpoyee: null,
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ],
      typeAction: ''
    }
  },
  beforeDestroy () {
    EventBus.$off('openDialogAddAprover')
  },
  mounted () {
    EventBus.$on('openDialogAddAprover', this.openDialogAddAprover)
  },
  watch: {
    radios (val) {
      if (val === 'ตนเอง') {
        this.img = ''
        this.employeeIdDefault = ''
        // this.employeeIdDefault = this.$store.state.user.employeeId
        this.employeeIdDefault = this.$store.state.user.emailOneId
        this.searchEmployee(this.$store.state.user.emailOneId)
      } else if (val === 'EmailOneID') {
        this.failed_image = false
        // this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        // this.getUser()
      } else if (val === 'ค้นหาจาก One ID') {
        this.failed_image = false
        this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        // this.searchEmployeeOne()
      }
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    // this.getUser()
  },
  methods: {
    onImgError () {
      this.failed_image = true
    },
    openDialogAddAprover (value, item, action, index, type) {
      // this.onImgError()
      // console.log('Data Dialog add approver :', value, type, item, action, index)
      this.loading = true
      this.getUser(item.email)
      this.img = ''
      this.searchEmpoyee = ''
      this.employeeIdDefault = ''
      this.dataSearchEmployee = ''
      this.radios = 'EmailOneID'
      this.action = action
      this.index = index
      this.type = type
      // this.dataSearchEmployee = item.approverName
      this.dataSearchEmployee = item.email
      // this.dialogApprover = value
      if (this.action === 'edit') {
        this.typeAction = 'แก้ไข'
        this.radios = 'EmailOneID'
        this.searchEmployee(item.email)
        this.searchEmpoyee = item.email
      } else if (this.action === 'add') {
        this.typeAction = 'เพิ่ม'
        // console.log('add')
      }
    },
    closeDialog () {
      this.clearSearchEmployee()
    },
    clearSearchEmployee () {
      this.loadingUsers = true
      this.radios = null
      this.dataSearchEmployee = ''
      this.searchEmpoyee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.email = ''
      this.img = ''
      this.id = ''
      this.companyName = ''
      this.dialogApprover = false
      this.loadingUsers = false
      EventBus.$emit('closeApprover', false)
    },
    async getUser (value) {
      // this.loading = true
      this.loadingUsers = true
      var temp = []
      const obj = {
        name: value
      }
      try {
        // const res = await getUserByKeyword(obj, this.tokenUser) // เก่า
        const res = await getUserByEmployee(obj, this.tokenUser) // ใหม่
        // console.log('res', res)
        if (res.success) {
          if (res.selector.length) {
            res.selector.map((el, index) => {
              if (el.userImg === '') {
                el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              }
              temp.push({
                no: index + 1,
                dataShow: el.emailOneId,
                ...el
              })
            })
          }
          // temp = res.result
          this.itemUser = temp
          this.loading = false
          this.dialogApprover = true
          // this.dataSearchEmployee = temp[0].employeeId
          // this.fNameTh = temp[0].fNameTh
          // this.email = temp[0].email
          // this.position = temp[0].positionName.position
          // this.img = temp[0].userImg
        }
      } catch (error) {
        console.log(error)
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    async searchEmployee (value) {
      this.loading = true
      // this.loadingUsers = true
      const obj = {
        name: value
      }
      try {
        // const res = await getUserByKeyword(obj, this.tokenUser) // เก่า
        const res = await getUserByEmployee(obj, this.tokenUser) // ใหม่
        // console.log('Res add approver', res)
        if (res.selector[0]) {
          this.id = res.selector[0].employee_id
          this.fNameTh = res.selector[0].titleTh + res.selector[0].name
          this.employeeId = res.selector[0].employeeId
          this.position = res.selector[0].position
          this.email = res.selector[0].emailOneId
          this.img = res.selector[0].userImg
          // this.companyName = res.selector[0].companyName
          // this.companyId = res.selector[0].companyId
          if (this.img === '') {
            this.img = `${hostImageUrlv3}/_/${res.selector[0].emailOneId}`
          } else {
            this.img = `${hostImageUrlv3}/${res.selector[0].userImg}/${res.selector[0].emailOneId}`
          }
          this.loading = false
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    async searchEmployeeOne () {
      // this.loading = true
      // this.loadingUsers = true
      const obj = {
        search: 'sittikorn0993'
      }
      try {
        const res = await searchSelectEmployee(obj, this.$store.state.token)
        // console.log('Res add approver One', res)
        if (res.result[0]) {
          this.id = res.result[0]._id
          this.fNameTh = res.result[0].name
          this.employeeId = res.result[0].employeeId
          this.position = res.result[0].position.positionName
          this.email = res.result[0].email
          this.img = res.result[0].userImg
          this.companyName = res.result[0].companyName
          this.companyId = res.result[0].companyId
          if (this.img === '') {
            this.img = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
          } else {
            this.img = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
          }
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    confirmApprove () {
      if (this.dataSearchEmployee === '' || this.employeeId === '') {
        swal('คำเตือน', 'กรุณากรอกรหัสพนักงานที่ต้องการค้นหา', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        var valueList = {
          id: this.id,
          name: this.fNameTh,
          employeeId: this.employeeId,
          nickname: '',
          position: this.position,
          email: this.email,
          approveType: this.approveType,
          companyId: this.companyId,
          userImg: this.img
        }
        // console.log('result add', valueList, this.type)
        EventBus.$emit('addAprover', valueList, this.index, this.action, this.type)
        this.type = ''
        this.dialogApprover = false
        this.fNameTh = ''
        this.lNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.img = ''
        this.onImgError()
        // swal('Success', 'โอนย้ายสิทธิ์ สำเร็จ', 'success')
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
